import Proper from '../components/Proper.vue'
import { SCHEDU_SEARCH_CONFIG_STATUS } from '@/common/schedule/Search'

// 默认导出表
export default function () {
  return [
    {
      title: $t('integration.number'),
      index: 'relay_code',
      popover: {
        component: Proper,
        attrs: {
          typeWay: this.$attrs.sensorWay
        }
      },
      icon: [
        {
          type: 'relayType',
          index: 'type',
          extClass: 'icon'
        }
      ]
    },
    {
      title: $t('integration.customer'),
      index: 'scopeName',
      power: ['isSysAdmin', 'isSysNoAdmin']
    },
    {
      title: $t('integration.archit_'),
      index: 'sceneName'
    },
    {
      title: $t('integration.monitoring_point'),
      index: 'carrierName',
      icon: [
        {
          type: 'carrierType',
          index: 'carrierType',
          title: $t('integration.monitoring_point_details'),
          click: this.carrierDetailFn
        }
      ]
    },
    {
      title: $t('integration.describe'),
      index: 'description'
    },
    {
      title: $t('integration.operation'),
      operation: [
        {
          type: 'stop',
          tip: true,
          click: this.stopUseFn
        },
        {
          type: 'config',
          click: this.configFn
        },
        {
          type: 'detail',
          click: this.detailFn
        }
      ]
    }
  ]
}

// 搜索条件
export const searchCondi = [
  {
    id: 1,
    text: $t('integration.trunk_number'),
    type: 'input',
    paramsName: 'code',
    isChooze: true
  },
  {
    id: 5,
    text: $t('integration.relay_type'),
    type: 'select',
    paramsName: 'type',
    selectParam: [],
    isChooze: false
  },
  {
    id: 2,
    text: $t('integration.running_state_'),
    type: 'select',
    paramsName: 'status',
    isChooze: false,
    selectParam: [
      {
        value: '',
        icon: 'el-icon-thumb',
        label: 'public.please'
      },
      {
        value: 0,
        icon: 'iconfont icon-wu-WiFi',
        label: 'selectMsg.Offline'
      },
      {
        value: 1,
        icon: 'iconfont icon-wifi',
        label: 'selectMsg.Online'
      }
    ]
  },
  {
    id: 3,
    text: $t('integration.mount_'),
    type: 'input',
    paramsName: 'carrierName',
    isChooze: false
  },
  SCHEDU_SEARCH_CONFIG_STATUS
]
